// import * as ImageCompressor from "react-native-compressor";
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../redux/root';
import { UserInfos } from '../types';
import { getAvatarFromUid } from './api/storage.api';
import { getUserByUid, getUsersCount } from './api/user.api';

export function useAvatar(uid: string) {
  const [image, setImage] = useState<string>();
  useEffect(() => {
    getAvatarFromUid(uid)
      .then((res) => {
        console.log('avatar', res);
        if (res) {
          setImage(res);
        }
      })
      .catch((ex) => null);
  }, []);
  return image;
}

export function useUserByUid(uid: string) {
  const [driver, setDriver] = React.useState<UserInfos | null>();

  React.useEffect(() => {
    getUserByUid(uid).then((res) => setDriver(res));
  }, []);

  return driver;
}

export const SWAL_DEFAULT_PROPS = {
  confirmButtonColor: '#0F7C55',
  iconColor: '#0F7C55',
  cancelButtonColor: '#DB3250'
};

export function useDashboard() {
  const { khassida, alquran, azkaar } = useAppSelector((s) => s);

  const [usersCount, setUsersCount] = useState(0);

  useEffect(() => {
    getUsersCount().then((count) => setUsersCount(count));
  }, []);

  return {
    khassida: khassida.length,
    alquran: alquran.length,
    users: usersCount,
    azkaar: azkaar.length
  };
}
